export default function WarningAmberIcon({ color = 'currentColor', size = 20 }: { color?: string; size?: number }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 21.5L12 2.5L23 21.5H1ZM4.45 19.5H19.55L12 6.49L4.45 19.5ZM12 18.3C12.2833 18.3 12.521 18.204 12.713 18.012C12.905 17.82 13.0007 17.5827 13 17.3C13 17.0167 12.904 16.779 12.712 16.587C12.52 16.395 12.2827 16.2993 12 16.3C11.7167 16.3 11.479 16.396 11.287 16.588C11.095 16.78 10.9993 17.0173 11 17.3C11 17.5833 11.096 17.821 11.288 18.013C11.48 18.205 11.7173 18.3007 12 18.3ZM11 15.3H13V10.3H11V15.3Z"
                fill={color}
            />
        </svg>
    );
}
